import { InputText } from 'primereact/inputtext';
import React, { useEffect, useRef, useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Image from '../../../components/AnnouncementComponents/Image';
import axiosInstance from '../../../core/axiosInstance';
import { useAppDispatch, useAppSelector } from '../../../core/hooks';
import { openTemp, selectTempPerview } from '../../../features/previewedPage/previewTempSlice';
import { AddAnnounce, ButtonGroup, GoldenButton, GoldenButtonBorder, HeaderContent, Label } from '../CreateAnnounce/CreateAnnounce.style';
import { BodyContent, MainTitle } from '../Main/Main.style';
import TempImage from './TempImage';
import { classNames } from 'primereact/utils';

const AddTemplate = () => {
    const dispatch = useAppDispatch();
    const temp = useAppSelector(selectTempPerview);
    const [method, setMethod] = useState<string>('add');
    const [tempImg, setTempImg] = useState([]);
    const [images, setImages] = useState([]);
    const [imgIds, setImgIds] = useState([]);
    const [file, setFiles] = useState<any>([]);
    let navigate = useNavigate()
    let formData = new FormData();
    const submitBtn: any = useRef(null);
    let status = 0;
    const saveTemplates = () => {
    }
    const getFormErrorMessage = (name: string) => {
      return (errors[`${name}`] && (<small className="p-error">{errors ? errors[`${name}`]?.message : null}</small>));
    };
    const defaultValues: any = {
        name: temp.temp.name,
        image: temp.temp.path,
    };
    useEffect(() => {
        if (temp.temp.id) {
          setMethod('edit');
        }
        return () => {
          dispatch(openTemp({ temp: {} }));
        };
      }, []);
      const onSubmit = async (data: any) => {
        try {
          let requestData: any;
          formData.append('name', data['name'])
          if(data['name'].trim().length == 0){
            toast.error('Please type template name', { position: toast.POSITION.TOP_CENTER, })
          }else if(data['name'].trim().length > 30){
            toast.error("Maximum Length is 30 characters", { position: toast.POSITION.TOP_CENTER, })
          }else if(file.length === 0 && method === 'add'){
              toast.error('Select an Image.', { position: toast.POSITION.TOP_CENTER, })
          } else {
            formData.append(`image`, file);
            requestData = formData;
            
            const prefix = method === 'add' ? '/dashboard/template/add' : `/dashboard/template/edit/${temp.temp.id}`;
            const res = await axiosInstance.post<any>(prefix, requestData)
            .then((res: any) => {
                if(res.data.message === "Template name already exists"){
                    toast.error(res.data.message, { position: toast.POSITION.TOP_CENTER, });
                } else {
                    toast.success('Your template has been set successfully', { position: toast.POSITION.TOP_CENTER, });
                    navigate('/templates');
                }
            })
          }
        } catch (err: any) {
          formData = new FormData();
        }
      };
      const { control, formState: { errors }, handleSubmit, } = useForm({ defaultValues });
    return (<>
    <AddAnnounce>
        <HeaderContent>
            <MainTitle title="HR Department">{ }</MainTitle>
            <ButtonGroup>
            <GoldenButton onClick={() => submitBtn.current.click()} > Save </GoldenButton>
            </ButtonGroup>
        </HeaderContent>

        <BodyContent>
        <h3>{method === 'add' ? 'New Templates' : 'Edit Templates'}</h3>
        <form onSubmit={handleSubmit(onSubmit)} className="p-fluid">
          <button ref={submitBtn} type="submit" hidden></button>
          <div className="">
            <div className="p-col-12 p-md-4 p-lg-3">
              <Label htmlFor="name"  className={classNames({ '': errors[`name`], })}> Announcement Name </Label>
            </div>
            <div className="p-col-12 p-md-8 p-lg-9">
                <Controller name="name" control={control} rules={{ required: '*Required', pattern:{ value: /[^0-9]/, message: "Can't be a number" } }}
                    render={({ field, fieldState }) => (
                    <InputText type="text" id={field.name} {...field} placeholder="Enter Name"
                    className={classNames({ 'p-invalid': fieldState.invalid, 'p-mt-2': true, })} />)}
                />
                {getFormErrorMessage('name')}
            </div>
          </div>
          {/* <div className="p-grid">
              <TempImage old={defaultValues.image} setFiles={setFiles} files={file} setimageids={setTempImg} imgIds={tempImg} />
          </div> */}
        </form>
        <span style={{ fontSize: '.8vw', position: 'absolute', color: '#5e0000', backgroundColor: '#ffa60045' , bottom: '1vh', left: "2vw" }}></span>
      </BodyContent>
    </AddAnnounce>
    </>);
}

export default AddTemplate;